module.exports = __webpack_public_path__ + "static/media/favicon.aa78d046.ico";